<template lang="pug">
  
  div( id="login-wrapper" class="" )
    MHeader
    div( class="loginscreen" )
      div( class="align-middle text-center" )
        div( class="m-b" )
          img( src="../vendor/images/logo-white.png" alt="Moonpull" )
        
        div( v-if="isLoggingIn" class="mb-4 text-center text-white h4" )
          MLoadingSpinner( class="mr-2" )
          | Logging in...

        div( v-else-if="showForgotPassword" )
          button( class="btn btn-link" v-on:click="showForgotPassword = false" )
            i( class="fa fa-caret-left mr-2" )
            | Back to login

          p We'll send a recovery link to:
          input( class="form-control m-b" placeholder="Email" type="email" v-model="forgotPasswordEmail" v-bind:disabled="resetPasswordLoading" )
          button( class="btn btn-primary block full-width" v-bind:disabled="resetPasswordLoading" v-on:click="initResetPassword" )
            MLoadingSpinner( class="mr-2" v-if="resetPasswordLoading" )
            | Send recovery link

        div( v-else-if="showResetPassword" )

          p Resetting password for: {{ resetPasswordUser.email }}
          p( class="password-reqs" ) Password must be at least 8 characters with at least one uppercase, lowercase, number and special character.

          input( class="form-control m-b" placeholder="New Password" type="password" v-model="resetPasswordNewPassword" v-bind:disabled="resetPasswordLoading" )
          input( class="form-control m-b" placeholder="Confirm Password" type="password" v-model="resetPasswordNewPasswordConfirm" v-bind:disabled="resetPasswordLoading" )

          button( class="btn btn-primary block full-width" v-bind:disabled="resetPasswordLoading" v-on:click="resetPassword" )
            MLoadingSpinner( class="mr-2" v-if="resetPasswordLoading" )
            | Reset password

        div( v-else )
        
          form( class="m-t" role="form" v-on:submit.prevent="login" )
            div( class="form-group text" )
              input( type="text" class="form-control" placeholder="Username" autocomplete="off" v-model="username" name="username" )
              label Username

            div( class="form-group password" )
              input( type="password" class="form-control" placeholder="Password" autocomplete="off" v-model="password" name="password" )
              label Password

            button( type="submit" class="btn btn-primary block full-width m-b" v-bind:disabled="loading" )
              | Login
              i( class="fa fa-spinner fa-spin ml-2" v-if="loading" )
          
          button( class="btn btn-link" v-on:click="showForgotPassword = true" ) Forgot password?
          br
          a( v-if="ssoLoginUrl" class="btn btn-link" v-bind:href="ssoLoginUrl" ) Enterprise Login

        p( class="m-t" )
          small Moonpull &copy; {{ (new Date()).getFullYear() }}

</template>

<style lang="scss" scoped>
.password-reqs {
  font-size: 0.9em;
}
</style>

<script>
import Vue from 'vue'
import gql from 'graphql-tag'
export default Vue.extend({

  data() {
    return {
      username: '',
      password: '',
      loading: false,
      errors: false,
      errorMessage: '',
      showForgotPassword: false,
      forgotPasswordEmail: '',
      resetPasswordLoading: false,
      showResetPassword: false,
      resetPasswordUser: null,
      resetPasswordNewPassword: '',
      resetPasswordNewPasswordConfirm: '',
      ssoLoginUrl: null,
      isLoggingIn: false,
    }
  },
  
  methods: {

    login() {
      this.loading = true
      this.$moonpull.login(this.username, this.password).then(() => this.loading = false)
    },

    async initResetPassword() {
      this.resetPasswordLoading = true
      await this.$moonpull.initResetPassword(this.forgotPasswordEmail)
      this.resetPasswordLoading = false
      this.showForgotPassword = false
      this.$store.dispatch('flashMessage', { type: 'success', msg: `If a Moonpull account exists for your email, you will receive a password reset email shortly.` })
    },

    async resetPassword() {
      
      if (this.resetPasswordNewPassword !== this.resetPasswordNewPasswordConfirm) {
        this.$store.dispatch('flashMessage', { type: 'danger', msg: `Passwords must match exactly`})
        return false
      }

      this.resetPasswordLoading = true
      const resetPasswordSuccess = await this.$moonpull.resetPassword(this.$route.query.resetToken, this.resetPasswordNewPassword)
      this.resetPasswordLoading = false
      if (resetPasswordSuccess) {
        this.showResetPassword = false
        this.showForgotPassword = false
        this.$store.dispatch('flashMessage', { type: 'success', msg: `Your password has been successfully reset` })
      }
    }

  },

  async beforeCreate() {

    // Redirect users who are already logged in
    if (await this.$moonpull.isLoggedIn()) {
      this.$router.push({ name: 'reporting-batches' })
      return
    }

    // SAML errors
    const samlError = this.$route.query.error_description
    if (samlError) {
      this.$store.dispatch('flashMessage', { type: 'danger', msg: samlError })
    }

    // SSO token login
    const ssoCode = this.$route.query.code
    if (ssoCode) {
      this.isLoggingIn = true
      await this.$moonpull.exchangeSsoCode(ssoCode)
      this.isLoggingIn = false
    }

    // Reset password
    const resetToken = this.$route.query.resetToken
    if (resetToken) {
      const userFromResetToken = await this.$moonpull.getUserFromResetPasswordToken(resetToken)
      if (userFromResetToken) {
        this.showResetPassword = true
        this.resetPasswordUser = userFromResetToken
      }
    }

    // Load SSO URL
    this.ssoLoginUrl = await this.$moonpull.getSsoUrl()
  }

})
</script>
